import { render, staticRenderFns } from "./IssuanceDocumentDropoffForm.vue?vue&type=template&id=08db4571"
import script from "./IssuanceDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./IssuanceDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports